import React, { Component, useContext } from "react";
import { Menu, Dropdown, Row, Col, Button } from "antd";
import Cookies from "universal-cookie";
import { GlobalOutlined } from "@ant-design/icons";
import { withAppContext } from "contexts/AppContext/AppContext";
// import { PrimaryColor } from "../../../tools/Constant/Constant";
import Locale from "react-intl-universal";

class Language extends Component {
  state = {};

  handle_change_language = (value) => {
    console.log(value);
    var today_date = new Date();
    var newdate = new Date(today_date);
    newdate.setDate(newdate.getDate() + 7);
    switch (value.key) {
      case "CN":
        //Set language cn-ZH
        var cookie = new Cookies();
        cookie.set("localization", "zh-CN", { expires: newdate });
        console.log(cookie.get("localization"));
        this.props.changeLocalization("zh-CN");
        window.location.reload();
        break;

      case "EN":
        //Set language en-US
        var cookie = new Cookies();
        cookie.set("localization", "en-US", { expires: newdate });
        console.log(cookie.get("localization"));
        this.props.changeLocalization("en-US");
        window.location.reload();
        break;

      case "MY":
        //Set language ms-MY
        var cookie = new Cookies();
        cookie.set("localization", "ms-MY", { expires: newdate });
        console.log(cookie.get("localization"));
        this.props.changeLocalization("ms-MY");
        window.location.reload();
        break;
      default:
        break;
    }
  };
  render() {
    const menu = (
      <Menu onClick={this.handle_change_language}>
        <Menu.Item key="EN">
          <label style={{ fontWeight: 500, cursor: "pointer" }}>
            EN{" "}
            <label style={{ fontWeight: 400, cursor: "pointer" }}>
              English
            </label>
          </label>
        </Menu.Item>
        <Menu.Item key="CN">
          <label style={{ fontWeight: 500, cursor: "pointer" }}>
            CN{" "}
            <label style={{ fontWeight: 400, cursor: "pointer" }}>中文</label>
          </label>
        </Menu.Item>
        {/* <Menu.Item key="MY">
          <label style={{ fontWeight: 500, cursor: "pointer" }}>
            MY{" "}
            <label style={{ fontWeight: 400, cursor: "pointer" }}>
              Bahasa Malaysia
            </label>
          </label>
        </Menu.Item> */}
      </Menu>
    );
    return (
      <Dropdown
        overlay={menu}
        trigger={window.innerWidth < 1368 ? ["click"] : ["hover"]}
        placement="bottomRight"
      >
        <Button
          style={{
            padding: "8px 16px",
            cursor: "pointer",
          }}
        >
          <Row gutter={8} align="middle">
            <Col>
              <GlobalOutlined
                style={{
                  fontSize: 12,
                  cursor: "pointer" /* , color: "#fff" */,
                }}
              />
            </Col>
            <Col>{Locale.get("dropDownHeader.language")}</Col>
          </Row>
        </Button>
      </Dropdown>
    );
  }
}

export default withAppContext(Language);
